import { makeSelectors } from '@utils/css';

const cell = "dibc3lpvs9";
const cellContent = "dibc1tom4ek";
const cellSelectors = makeSelectors({
  cell,
  cellContent
});

export { cell, cellContent, cellSelectors };
import "./cell.style.linaria.module.css";
//# sourceMappingURL=cell.style.js.map
